import React from 'react';
import { cn } from '../utils';

const EmptyState = ({ icon: Icon, title, description, variant = 'indigo', action }) => {
  const variants = {
    purple: {
      bg: 'bg-purple-50',
      icon: 'text-purple-400',
      title: 'text-gray-900',
      description: 'text-gray-500',
      border: 'border-purple-100'
    },
    green: {
      bg: 'bg-green-50/30',
      icon: 'text-green-200',
      title: 'text-green-700',
      description: 'text-green-600/60',
      border: 'border-green-100'
    },
    indigo: {
      bg: 'bg-gray-50',
      icon: 'text-gray-300',
      title: 'text-gray-500',
      description: 'text-gray-400',
      border: 'border-gray-100'
    }
  };

  const style = variants[variant] || variants.indigo;

  return (
    <div className={cn(
      "flex-1 flex flex-col items-center justify-center text-center p-12 rounded-3xl border-2 border-dashed",
      style.bg,
      style.border
    )}>
      <div className={cn(
        "w-20 h-20 bg-white rounded-3xl shadow-sm flex items-center justify-center mb-6",
        style.icon
      )}>
        <Icon size={40} />
      </div>
      <h3 className={cn("text-lg font-bold mb-2", style.title)}>{title}</h3>
      <p className={cn("text-sm font-medium max-w-[260px] leading-relaxed mb-6", style.description)}>
        {description}
      </p>
      {action && (
        <div className="animate-in fade-in slide-in-from-bottom-2 duration-500">
          {action}
        </div>
      )}
    </div>
  );
};

export default EmptyState;
